import { motion } from "framer-motion";
import { PROBLEMS } from "@/lib/data";
import { Reveal, Label } from "@/components/Reveal";

export default function Problem() {
  return (
    <section data-testid="problem" className="relative py-24 md:py-32 bg-[#0A0E14]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Label>01 — Il problema</Label>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 max-w-3xl">
            Un&apos;idea che resta bloccata è un&apos;occasione persa.
          </h2>
        </Reveal>

        <div className="mt-14 border-t border-white/10">
          {PROBLEMS.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`problem-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group grid grid-cols-12 gap-4 md:gap-8 items-start py-8 border-b border-white/10 hover:bg-white/[0.02] transition-colors px-2"
            >
              <span className="col-span-2 md:col-span-1 font-mono-tech text-sm text-[#00C8D7] pt-1">
                0{i + 1}
              </span>
              <p className="col-span-10 md:col-span-11 text-lg md:text-xl text-slate-300 leading-snug group-hover:text-white transition-colors">
                {p}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
